import {
    Box,
    chakra,
    Container,
    Image,
    Stack,
    Text,
    useColorModeValue,
    useBreakpointValue,
    VisuallyHidden,
    Center,
    Grid,
    Flex,
    SimpleGrid, GridItem
} from '@chakra-ui/react';
export default function NotFound() {
        const colors = {
    black: "#000000",
    pink: "#e10ea5",
    yellow: "#d3c615",
    red: "#f21d1b",
    orangeRed: "#f31f1c",
    teal: "#1da179",
    green1: "#1b9872",
    green2: "#1d9e77",
    };
    return (
        <Box py={16} px={6} >
        <Container textAlign='center' maxW={'7xl'} height={['100%', '500px']} position="relative" overflow='hidden'>
            <Container maxW={'6xl'} py={10}>
                {/* Header */}
                <Center mb={10}>
                    <Text color={colors.teal} fontSize="3xl" fontWeight="bold">
                        404
                    </Text>
                </Center>
                <SimpleGrid columns={{ base: 1, md: 3 }} gap={{ base: "5px", md: "30px" }}>
                    <GridItem colSpan={{ base: 1, md: 3 }}>
                        <Box p='50px' fontWeight='bold'>
                            <Text lineClamp="2">
                                You do not have permission to access this page
                            </Text>
                        </Box>
                    </GridItem>
                </SimpleGrid>
            </Container>
        </Container>
      </Box>
    );
}